// Cliente 360 (/console/cliente/:code): permiso propio y mensaje de error legible.
// Es el permiso de Contactos → Vista de morosidad → «Ver detalle completo», independiente de
// Cobranza → Cartera y Mora.
export const PERMISO_CLIENTE_360 = 'contactos.vista_morosidad.ver_detalle_completo';

export const mensajeErrorCliente360 = (err: any): string => {
  if (err?.status === 403) return 'No tienes permiso para ver el detalle completo del cliente';
  if (err?.status === 404) return 'Cliente no encontrado';
  const msg = err?.error?.error || err?.error?.msg;
  if (typeof msg === 'string' && msg.trim()) return msg;
  return 'No se pudo cargar el detalle del cliente. Intenta de nuevo.';
};
